import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { useEffect } from 'preact/hooks';
import { X } from 'lucide-preact';
import { SettingsProfile } from '../settings/SettingsProfile';
export function UserSettingsDrawer({ isOpen, onClose }) {
    // Close on Escape key
    useEffect(() => {
        if (!isOpen)
            return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);
    // Prevent body scroll when drawer is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [isOpen]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: `fixed inset-0 bg-black z-40 transition-opacity duration-300 ${isOpen ? 'opacity-50 pointer-events-auto' : 'opacity-0 pointer-events-none'}`, onClick: onClose }), _jsxs("div", { className: `
          fixed inset-y-0 right-0 z-50
          w-full sm:w-[640px] lg:w-[780px]
          bg-white dark:bg-slate-900 border-l border-slate-200 dark:border-slate-700
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : 'translate-x-full'}
          flex flex-col overflow-hidden
        `, children: [_jsxs("div", { className: "flex items-center justify-between px-6 py-4 border-b border-slate-200 dark:border-slate-700", children: [_jsx("h2", { className: "text-lg font-semibold text-slate-900 dark:text-white", children: "Account" }), _jsx("button", { onClick: onClose, className: "p-2 rounded-lg text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors", children: _jsx(X, { className: "h-5 w-5" }) })] }), _jsx("div", { className: "flex-1 overflow-y-auto", children: _jsx(SettingsProfile, {}) })] })] }));
}
